export default __webpack_public_path__ + "static/media/Inter-UI-ExtraLightItalic-BETA.2711e846.woff";